module.exports = __webpack_public_path__ + "web/img/level-1.a36ea9a7.png";